export default function pendoUpdateOptions(userObject)
{
  window.pendo.updateOptions({
    visitor: userObject
  });
}
